import {
  RenderPartInformationProps,
  RenderQuoteItemInformationProps
} from './quoteProcurementPartInfo';
import { IRenderSupplierInventoryInformation } from './quoteProcurementPartInfoColumn';

export function getQuoteItemInformationText({
  quoteItemDescription,
  quoteItemPartNumber
}: RenderQuoteItemInformationProps) {
  if (quoteItemDescription && quoteItemPartNumber) {
    return `${quoteItemDescription} - ${quoteItemPartNumber}`;
  } else if (quoteItemDescription) {
    return quoteItemDescription;
  } else if (quoteItemPartNumber) {
    return quoteItemPartNumber;
  }

  return '';
}

export function getRenderPartInformationText({
  partName,
  partPosition
}: RenderPartInformationProps) {
  let partInfo: string = '';

  if (partName) {
    partInfo = partName;

    if (partPosition) {
      partInfo += ` - ${partPosition}`;
    }

    return partInfo;
  }

  if (partPosition) {
    return partPosition;
  }

  return '';
}

export function getPartTypeAndBrandText(
  partType: string | undefined,
  partBrand: string | undefined,
  withoutConcat: boolean,
  partTypeQuoteItem: string | undefined
) {
  if (partType) {
    let partTypeAndBrand: string = '';
    if (partBrand) {
      partTypeAndBrand += `(${partBrand})`;
    }

    if (!withoutConcat) {
      partTypeAndBrand = `${partTypeAndBrand} `;
    }

    return partTypeAndBrand;
  }
}

export function getRenderSupplierInventoryInformationText({
  supplierInventoryPartTitle,
  partBrand,
  partType,
  showLineSupplierInfo,
  partTypeQuoteItem
}: IRenderSupplierInventoryInformation) {
  let supplierInventoryInfo: string = '';

  if (showLineSupplierInfo) {
    if (showLineSupplierInfo?.info === 'all') {
      if (supplierInventoryPartTitle) {
        supplierInventoryInfo = supplierInventoryPartTitle;

        if (partType) {
          supplierInventoryInfo +=
            ' - ' +
            getPartTypeAndBrandText(
              partType,
              partBrand,
              true,
              partTypeQuoteItem
            );
        }

        return supplierInventoryInfo;
      }
      return getPartTypeAndBrandText(
        partType,
        partBrand,
        true,
        partTypeQuoteItem
      );
    } else if (showLineSupplierInfo?.info === 'partType') {
      return getPartTypeAndBrandText(
        partType,
        partBrand,
        true,
        partTypeQuoteItem
      );
    }
  }

  return '';
}
